<div
  v-if="shouldRenderConfig && getPreview3D!=''"
  v-bind:class="[getClassName + 'Container', visible]"
>
  <vue-friendly-iframe :id="get3DPreviewId" :src="getPreview3D" @load="onLoad">
  </vue-friendly-iframe>
</div>
